import { n as Q, m as s, u as a, g as w, o as B, p as J } from "./CSSMotionList.js";
import "react";
import { g as K } from "./compact-item.js";
function br(r, o, e) {
  return Q({
    [`${r}-status-success`]: o === "success",
    [`${r}-status-warning`]: o === "warning",
    [`${r}-status-error`]: o === "error",
    [`${r}-status-validating`]: o === "validating",
    [`${r}-has-feedback`]: e
  });
}
const $r = (r, o) => o || r;
function y(r) {
  return s(r, {
    inputAffixPadding: r.paddingXXS
  });
}
const E = (r) => {
  const {
    controlHeight: o,
    fontSize: e,
    lineHeight: i,
    lineWidth: t,
    controlHeightSM: d,
    controlHeightLG: n,
    fontSizeLG: l,
    lineHeightLG: c,
    paddingSM: u,
    controlPaddingHorizontalSM: H,
    controlPaddingHorizontal: T,
    colorFillAlter: F,
    colorPrimaryHover: G,
    colorPrimary: M,
    controlOutlineWidth: g,
    controlOutline: L,
    colorErrorOutline: A,
    colorWarningOutline: D,
    colorBgContainer: $,
    inputFontSize: P,
    inputFontSizeLG: q,
    inputFontSizeSM: X
  } = r, p = P || e, h = X || p, S = q || l, _ = Math.round((o - p * i) / 2 * 10) / 10 - t, U = Math.round((d - h * i) / 2 * 10) / 10 - t, N = Math.ceil((n - S * c) / 2 * 10) / 10 - t;
  return {
    paddingBlock: Math.max(_, 0),
    paddingBlockSM: Math.max(U, 0),
    paddingBlockLG: Math.max(N, 0),
    paddingInline: u - t,
    paddingInlineSM: H - t,
    paddingInlineLG: T - t,
    addonBg: F,
    activeBorderColor: M,
    hoverBorderColor: G,
    activeShadow: `0 0 0 ${g}px ${L}`,
    errorActiveShadow: `0 0 0 ${g}px ${A}`,
    warningActiveShadow: `0 0 0 ${g}px ${D}`,
    hoverBg: $,
    activeBg: $,
    inputFontSize: p,
    inputFontSizeLG: S,
    inputFontSizeSM: h
  };
}, V = (r) => ({
  borderColor: r.hoverBorderColor,
  backgroundColor: r.hoverBg
}), b = (r) => ({
  color: r.colorTextDisabled,
  backgroundColor: r.colorBgContainerDisabled,
  borderColor: r.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled], textarea[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, V(s(r, {
    hoverBorderColor: r.colorBorder,
    hoverBg: r.colorBgContainerDisabled
  })))
}), R = (r, o) => ({
  background: r.colorBgContainer,
  borderWidth: r.lineWidth,
  borderStyle: r.lineType,
  borderColor: o.borderColor,
  "&:hover": {
    borderColor: o.hoverBorderColor,
    backgroundColor: r.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: o.activeBorderColor,
    boxShadow: o.activeShadow,
    outline: 0,
    backgroundColor: r.activeBg
  }
}), f = (r, o) => ({
  [`&${r.componentCls}-status-${o.status}:not(${r.componentCls}-disabled)`]: Object.assign(Object.assign({}, R(r, o)), {
    [`${r.componentCls}-prefix, ${r.componentCls}-suffix`]: {
      color: o.affixColor
    }
  }),
  [`&${r.componentCls}-status-${o.status}${r.componentCls}-disabled`]: {
    borderColor: o.borderColor
  }
}), Y = (r, o) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, R(r, {
    borderColor: r.colorBorder,
    hoverBorderColor: r.hoverBorderColor,
    activeBorderColor: r.activeBorderColor,
    activeShadow: r.activeShadow
  })), {
    [`&${r.componentCls}-disabled, &[disabled]`]: Object.assign({}, b(r))
  }), f(r, {
    status: "error",
    borderColor: r.colorError,
    hoverBorderColor: r.colorErrorBorderHover,
    activeBorderColor: r.colorError,
    activeShadow: r.errorActiveShadow,
    affixColor: r.colorError
  })), f(r, {
    status: "warning",
    borderColor: r.colorWarning,
    hoverBorderColor: r.colorWarningBorderHover,
    activeBorderColor: r.colorWarning,
    activeShadow: r.warningActiveShadow,
    affixColor: r.colorWarning
  })), o)
}), m = (r, o) => ({
  [`&${r.componentCls}-group-wrapper-status-${o.status}`]: {
    [`${r.componentCls}-group-addon`]: {
      borderColor: o.addonBorderColor,
      color: o.addonColor
    }
  }
}), Z = (r) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${r.componentCls}-group`]: {
      "&-addon": {
        background: r.addonBg,
        border: `${a(r.lineWidth)} ${r.lineType} ${r.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, m(r, {
    status: "error",
    addonBorderColor: r.colorError,
    addonColor: r.colorErrorText
  })), m(r, {
    status: "warning",
    addonBorderColor: r.colorWarning,
    addonColor: r.colorWarningText
  })), {
    [`&${r.componentCls}-group-wrapper-disabled`]: {
      [`${r.componentCls}-group-addon`]: Object.assign({}, b(r))
    }
  })
}), k = (r, o) => {
  const {
    componentCls: e
  } = r;
  return {
    "&-borderless": Object.assign({
      background: "transparent",
      border: "none",
      "&:focus, &:focus-within": {
        outline: "none"
      },
      // >>>>> Disabled
      [`&${e}-disabled, &[disabled]`]: {
        color: r.colorTextDisabled,
        cursor: "not-allowed"
      },
      // >>>>> Status
      [`&${e}-status-error`]: {
        "&, & input, & textarea": {
          color: r.colorError
        }
      },
      [`&${e}-status-warning`]: {
        "&, & input, & textarea": {
          color: r.colorWarning
        }
      }
    }, o)
  };
}, O = (r, o) => {
  var e;
  return {
    background: o.bg,
    borderWidth: r.lineWidth,
    borderStyle: r.lineType,
    borderColor: "transparent",
    "input&, & input, textarea&, & textarea": {
      color: (e = o == null ? void 0 : o.inputColor) !== null && e !== void 0 ? e : "unset"
    },
    "&:hover": {
      background: o.hoverBg
    },
    "&:focus, &:focus-within": {
      outline: 0,
      borderColor: o.activeBorderColor,
      backgroundColor: r.activeBg
    }
  };
}, C = (r, o) => ({
  [`&${r.componentCls}-status-${o.status}:not(${r.componentCls}-disabled)`]: Object.assign(Object.assign({}, O(r, o)), {
    [`${r.componentCls}-prefix, ${r.componentCls}-suffix`]: {
      color: o.affixColor
    }
  })
}), rr = (r, o) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, O(r, {
    bg: r.colorFillTertiary,
    hoverBg: r.colorFillSecondary,
    activeBorderColor: r.activeBorderColor
  })), {
    [`&${r.componentCls}-disabled, &[disabled]`]: Object.assign({}, b(r))
  }), C(r, {
    status: "error",
    bg: r.colorErrorBg,
    hoverBg: r.colorErrorBgHover,
    activeBorderColor: r.colorError,
    inputColor: r.colorErrorText,
    affixColor: r.colorError
  })), C(r, {
    status: "warning",
    bg: r.colorWarningBg,
    hoverBg: r.colorWarningBgHover,
    activeBorderColor: r.colorWarning,
    inputColor: r.colorWarningText,
    affixColor: r.colorWarning
  })), o)
}), v = (r, o) => ({
  [`&${r.componentCls}-group-wrapper-status-${o.status}`]: {
    [`${r.componentCls}-group-addon`]: {
      background: o.addonBg,
      color: o.addonColor
    }
  }
}), or = (r) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${r.componentCls}-group-addon`]: {
      background: r.colorFillTertiary,
      "&:last-child": {
        position: "static"
      }
    }
  }, v(r, {
    status: "error",
    addonBg: r.colorErrorBg,
    addonColor: r.colorErrorText
  })), v(r, {
    status: "warning",
    addonBg: r.colorWarningBg,
    addonColor: r.colorWarningText
  })), {
    [`&${r.componentCls}-group-wrapper-disabled`]: {
      [`${r.componentCls}-group`]: {
        "&-addon": {
          background: r.colorFillTertiary,
          color: r.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${a(r.lineWidth)} ${r.lineType} ${r.colorBorder}`,
          borderTop: `${a(r.lineWidth)} ${r.lineType} ${r.colorBorder}`,
          borderBottom: `${a(r.lineWidth)} ${r.lineType} ${r.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${a(r.lineWidth)} ${r.lineType} ${r.colorBorder}`,
          borderTop: `${a(r.lineWidth)} ${r.lineType} ${r.colorBorder}`,
          borderBottom: `${a(r.lineWidth)} ${r.lineType} ${r.colorBorder}`
        }
      }
    }
  })
}), I = (r, o) => ({
  background: r.colorBgContainer,
  borderWidth: `${a(r.lineWidth)} 0`,
  borderStyle: `${r.lineType} none`,
  borderColor: `transparent transparent ${o.borderColor} transparent`,
  borderRadius: 0,
  "&:hover": {
    borderColor: `transparent transparent ${o.borderColor} transparent`,
    backgroundColor: r.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: `transparent transparent ${o.borderColor} transparent`,
    outline: 0,
    backgroundColor: r.activeBg
  }
}), x = (r, o) => ({
  [`&${r.componentCls}-status-${o.status}:not(${r.componentCls}-disabled)`]: Object.assign(Object.assign({}, I(r, o)), {
    [`${r.componentCls}-prefix, ${r.componentCls}-suffix`]: {
      color: o.affixColor
    }
  }),
  [`&${r.componentCls}-status-${o.status}${r.componentCls}-disabled`]: {
    borderColor: `transparent transparent ${o.borderColor} transparent`
  }
}), er = (r, o) => ({
  "&-underlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, I(r, {
    borderColor: r.colorBorder,
    hoverBorderColor: r.hoverBorderColor,
    activeBorderColor: r.activeBorderColor,
    activeShadow: r.activeShadow
  })), {
    // >>>>> Disabled
    [`&${r.componentCls}-disabled, &[disabled]`]: {
      color: r.colorTextDisabled,
      boxShadow: "none",
      cursor: "not-allowed",
      "&:hover": {
        borderColor: `transparent transparent ${r.colorBorder} transparent`
      }
    },
    "input[disabled], textarea[disabled]": {
      cursor: "not-allowed"
    }
  }), x(r, {
    status: "error",
    borderColor: r.colorError,
    hoverBorderColor: r.colorErrorBorderHover,
    activeBorderColor: r.colorError,
    activeShadow: r.errorActiveShadow,
    affixColor: r.colorError
  })), x(r, {
    status: "warning",
    borderColor: r.colorWarning,
    hoverBorderColor: r.colorWarningBorderHover,
    activeBorderColor: r.colorWarning,
    activeShadow: r.warningActiveShadow,
    affixColor: r.colorWarning
  })), o)
}), ar = (r) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: r,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), j = (r) => {
  const {
    paddingBlockLG: o,
    lineHeightLG: e,
    borderRadiusLG: i,
    paddingInlineLG: t
  } = r;
  return {
    padding: `${a(o)} ${a(t)}`,
    fontSize: r.inputFontSizeLG,
    lineHeight: e,
    borderRadius: i
  };
}, W = (r) => ({
  padding: `${a(r.paddingBlockSM)} ${a(r.paddingInlineSM)}`,
  fontSize: r.inputFontSizeSM,
  borderRadius: r.borderRadiusSM
}), z = (r) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${a(r.paddingBlock)} ${a(r.paddingInline)}`,
  color: r.colorText,
  fontSize: r.inputFontSize,
  lineHeight: r.lineHeight,
  borderRadius: r.borderRadius,
  transition: `all ${r.motionDurationMid}`
}, ar(r.colorTextPlaceholder)), {
  // Size
  "&-lg": Object.assign({}, j(r)),
  "&-sm": Object.assign({}, W(r)),
  // RTL
  "&-rtl, &-textarea-rtl": {
    direction: "rtl"
  }
}), ir = (r) => {
  const {
    componentCls: o,
    antCls: e
  } = r;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: r.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${o}, &-lg > ${o}-group-addon`]: Object.assign({}, j(r)),
    [`&-sm ${o}, &-sm > ${o}-group-addon`]: Object.assign({}, W(r)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${e}-select-single ${e}-select-selector`]: {
      height: r.controlHeightLG
    },
    [`&-sm ${e}-select-single ${e}-select-selector`]: {
      height: r.controlHeightSM
    },
    [`> ${o}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${o}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${a(r.paddingInline)}`,
        color: r.colorText,
        fontWeight: "normal",
        fontSize: r.inputFontSize,
        textAlign: "center",
        borderRadius: r.borderRadius,
        transition: `all ${r.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${e}-select`]: {
          margin: `${a(r.calc(r.paddingBlock).add(1).mul(-1).equal())} ${a(r.calc(r.paddingInline).mul(-1).equal())}`,
          [`&${e}-select-single:not(${e}-select-customize-input):not(${e}-pagination-size-changer)`]: {
            [`${e}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${a(r.lineWidth)} ${r.lineType} transparent`,
              boxShadow: "none"
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${e}-cascader-picker`]: {
          margin: `-9px ${a(r.calc(r.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${e}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [o]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${o}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${o}:first-child, ${o}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${e}-select ${e}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${o}-affix-wrapper`]: {
      [`&:not(:first-child) ${o}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${o}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${o}:last-child, ${o}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${e}-select ${e}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${o}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${o}-search &`]: {
          borderStartStartRadius: r.borderRadius,
          borderEndStartRadius: r.borderRadius
        }
      },
      [`&:not(:first-child), ${o}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${o}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, J()), {
      [`${o}-group-addon, ${o}-group-wrap, > ${o}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: r.lineWidth,
          "&:hover, &:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-flex",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${o}-affix-wrapper,
        & > ${o}-number-affix-wrapper,
        & > ${e}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: r.calc(r.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: r.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [o]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${e}-select > ${e}-select-selector,
      & > ${e}-select-auto-complete ${o},
      & > ${e}-cascader-picker ${o},
      & > ${o}-group-wrapper ${o}`]: {
        borderInlineEndWidth: r.lineWidth,
        borderRadius: 0,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`& > ${e}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${e}-select > ${e}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${e}-select:first-child > ${e}-select-selector,
      & > ${e}-select-auto-complete:first-child ${o},
      & > ${e}-cascader-picker:first-child ${o}`]: {
        borderStartStartRadius: r.borderRadius,
        borderEndStartRadius: r.borderRadius
      },
      [`& > *:last-child,
      & > ${e}-select:last-child > ${e}-select-selector,
      & > ${e}-cascader-picker:last-child ${o},
      & > ${e}-cascader-picker-focused:last-child ${o}`]: {
        borderInlineEndWidth: r.lineWidth,
        borderStartEndRadius: r.borderRadius,
        borderEndEndRadius: r.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${e}-select-auto-complete ${o}`]: {
        verticalAlign: "top"
      },
      [`${o}-group-wrapper + ${o}-group-wrapper`]: {
        marginInlineStart: r.calc(r.lineWidth).mul(-1).equal(),
        [`${o}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${o}-group-wrapper:not(:last-child)`]: {
        [`&${o}-search > ${o}-group`]: {
          [`& > ${o}-group-addon > ${o}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${o}`]: {
            borderStartStartRadius: r.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: r.borderRadius
          }
        }
      }
    })
  };
}, tr = (r) => {
  const {
    componentCls: o,
    controlHeightSM: e,
    lineWidth: i,
    calc: t
  } = r, n = t(e).sub(t(i).mul(2)).sub(16).div(2).equal();
  return {
    [o]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, B(r)), z(r)), Y(r)), rr(r)), k(r)), er(r)), {
      '&[type="color"]': {
        height: r.controlHeight,
        [`&${o}-lg`]: {
          height: r.controlHeightLG
        },
        [`&${o}-sm`]: {
          height: e,
          paddingTop: n,
          paddingBottom: n
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        appearance: "none"
      }
    })
  };
}, dr = (r) => {
  const {
    componentCls: o
  } = r;
  return {
    // ========================= Input =========================
    [`${o}-clear-icon`]: {
      margin: 0,
      padding: 0,
      lineHeight: 0,
      color: r.colorTextQuaternary,
      fontSize: r.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${r.motionDurationSlow}`,
      border: "none",
      outline: "none",
      backgroundColor: "transparent",
      "&:hover": {
        color: r.colorIcon
      },
      "&:active": {
        color: r.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${a(r.inputAffixPadding)}`
      }
    }
  };
}, nr = (r) => {
  const {
    componentCls: o,
    inputAffixPadding: e,
    colorTextDescription: i,
    motionDurationSlow: t,
    colorIcon: d,
    colorIconHover: n,
    iconCls: l
  } = r, c = `${o}-affix-wrapper`, u = `${o}-affix-wrapper-disabled`;
  return {
    [c]: Object.assign(Object.assign(Object.assign(Object.assign({}, z(r)), {
      display: "inline-flex",
      [`&:not(${o}-disabled):hover`]: {
        zIndex: 1,
        [`${o}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${o}`]: {
        padding: 0
      },
      [`> input${o}, > textarea${o}`]: {
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [o]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: r.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: i,
          direction: "ltr"
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: r.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: e
        },
        "&-suffix": {
          marginInlineStart: e
        }
      }
    }), dr(r)), {
      // password
      [`${l}${o}-password-icon`]: {
        color: d,
        cursor: "pointer",
        transition: `all ${t}`,
        "&:hover": {
          color: n
        }
      }
    }),
    // 覆盖 affix-wrapper borderRadius！
    [`${o}-underlined`]: {
      borderRadius: 0
    },
    [u]: {
      // password disabled
      [`${l}${o}-password-icon`]: {
        color: d,
        cursor: "not-allowed",
        "&:hover": {
          color: d
        }
      }
    }
  };
}, lr = (r) => {
  const {
    componentCls: o,
    borderRadiusLG: e,
    borderRadiusSM: i
  } = r;
  return {
    [`${o}-group`]: Object.assign(Object.assign(Object.assign({}, B(r)), ir(r)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${o}-group-addon`]: {
            borderRadius: e,
            fontSize: r.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${o}-group-addon`]: {
            borderRadius: i
          }
        }
      }, Z(r)), or(r)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${o}-compact-first-item):not(${o}-compact-last-item)${o}-compact-item`]: {
          [`${o}, ${o}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${o}-compact-last-item)${o}-compact-first-item`]: {
          [`${o}, ${o}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${o}-compact-first-item)${o}-compact-last-item`]: {
          [`${o}, ${o}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${o}-compact-last-item)${o}-compact-item`]: {
          [`${o}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        // Fix the issue of input use `addonAfter` param in space compact mode
        // https://github.com/ant-design/ant-design/issues/52483
        [`&:not(${o}-compact-first-item)${o}-compact-item`]: {
          [`${o}-affix-wrapper`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        }
      })
    })
  };
}, sr = (r) => {
  const {
    componentCls: o,
    antCls: e
  } = r, i = `${o}-search`;
  return {
    [i]: {
      [o]: {
        "&:hover, &:focus": {
          [`+ ${o}-group-addon ${i}-button:not(${e}-btn-color-primary):not(${e}-btn-variant-text)`]: {
            borderInlineStartColor: r.colorPrimaryHover
          }
        }
      },
      [`${o}-affix-wrapper`]: {
        height: r.controlHeight,
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
      [`${o}-lg`]: {
        lineHeight: r.calc(r.lineHeightLG).sub(2e-4).equal()
      },
      [`> ${o}-group`]: {
        [`> ${o}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${i}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${i}-button:not(${e}-btn-color-primary)`]: {
            color: r.colorTextDescription,
            "&:hover": {
              color: r.colorPrimaryHover
            },
            "&:active": {
              color: r.colorPrimaryActive
            },
            [`&${e}-btn-loading::before`]: {
              inset: 0
            }
          }
        }
      },
      [`${i}-button`]: {
        height: r.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      "&-large": {
        [`${o}-affix-wrapper, ${i}-button`]: {
          height: r.controlHeightLG
        }
      },
      "&-small": {
        [`${o}-affix-wrapper, ${i}-button`]: {
          height: r.controlHeightSM
        }
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${o}-compact-item`]: {
        [`&:not(${o}-compact-last-item)`]: {
          [`${o}-group-addon`]: {
            [`${o}-search-button`]: {
              marginInlineEnd: r.calc(r.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${o}-compact-first-item)`]: {
          [`${o},${o}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${o}-group-addon ${o}-search-button,
        > ${o},
        ${o}-affix-wrapper`]: {
          "&:hover, &:focus, &:active": {
            zIndex: 2
          }
        },
        [`> ${o}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
}, cr = (r) => {
  const {
    componentCls: o
  } = r;
  return {
    [`${o}-out-of-range`]: {
      [`&, & input, & textarea, ${o}-show-count-suffix, ${o}-data-count`]: {
        color: r.colorError
      }
    }
  };
}, hr = w(["Input", "Shared"], (r) => {
  const o = s(r, y(r));
  return [tr(o), nr(o)];
}, E, {
  resetFont: !1
}), Sr = w(["Input", "Component"], (r) => {
  const o = s(r, y(r));
  return [
    lr(o),
    sr(o),
    cr(o),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    K(o)
  ];
}, E, {
  resetFont: !1
});
export {
  E as a,
  hr as b,
  br as c,
  Y as d,
  er as e,
  rr as f,
  $r as g,
  k as h,
  y as i,
  ar as j,
  W as k,
  z as l,
  R as m,
  b as n,
  Sr as u
};
